const VIEWPORT_SIZES = {
    miniMobile: {
        width: 320,
        height: 480,
    },
    mobile: {
        width: 390,
        height: 844,
    },
    tablet: {
        width: 768,
        height: 1024,
    },
    desktop: {
        width: 1440,
        height: 900,
    },
    fluid: {
        width: "100%",
        height: "100%",
    },

    // Tailwind Viewports
    sm: {
        width: 640,
        height: 1136,
    },

    md: {
        width: 768,
        height: 1024,
    },

    lg: {
        width: 1024,
        height: 768,
    },

    xl: {
        width: 1280,
        height: 720,
    },

    "2xl": {
        width: 1536,
        height: 864,
    },

    "3xl": {
        width: 1920,
        height: 1080,
    },

    // Digital Signage
    signagePortrait: {
        width: 1080,
        height: 1920,
    },
    signageLandscape: {
        width: 1920,
        height: 1080,
    },

    // Slides — same canonical aspect ratios as PowerPoint / Keynote / Google
    // Slides. Heights match so the two viewports occupy the same scaled area
    // in the editor (easier visual A/B). 16:9 dimensions intentionally mirror
    // signageLandscape AND the Puppeteer thumbnail capture viewport so what
    // the user sees in the editor matches the exported thumbnail pixel-for-
    // pixel. Selection persists to slides.json `config.aspectRatio` (see
    // useSlideAspectRatio).
    slides16x9: {
        width: 1920,
        height: 1080,
    },
    slides4x3: {
        width: 1440,
        height: 1080,
    },
};

type ViewportSizeType = keyof typeof VIEWPORT_SIZES;

const ViewportSize = {
    miniMobile: "miniMobile" as ViewportSizeType,
    mobile: "mobile" as ViewportSizeType,
    tablet: "tablet" as ViewportSizeType,
    desktop: "desktop" as ViewportSizeType,
    fluid: "fluid" as ViewportSizeType,
    sm: "sm" as ViewportSizeType,
    md: "md" as ViewportSizeType,
    lg: "lg" as ViewportSizeType,
    xl: "xl" as ViewportSizeType,
    "2xl": "2xl" as ViewportSizeType,
    "3xl": "3xl" as ViewportSizeType,
    signagePortrait: "signagePortrait" as ViewportSizeType,
    signageLandscape: "signageLandscape" as ViewportSizeType,
    slides16x9: "slides16x9" as ViewportSizeType,
    slides4x3: "slides4x3" as ViewportSizeType,
};

export { VIEWPORT_SIZES, ViewportSize };
export type { ViewportSizeType };
